import React from 'react'

const FacebookIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#FF5612" />
            <path d="M12.9297 18V12.5266H14.7661L15.0417 10.3929H12.9297V9.03088C12.9297 8.41332 13.1005 7.99246 13.9871 7.99246L15.116 7.99199V6.08354C14.9208 6.05817 14.2506 6 13.4706 6C11.8419 6 10.7268 6.99418 10.7268 8.81956V10.3929H8.88477V12.5266H10.7268V18H12.9297Z" fill="white" />
        </svg>
    )
}

export default FacebookIcon